<template>
  <div
    class="fic"
    :class="{ 'fic--clickable': openOnClick }"
    role="button"
    tabindex="0"
    @click="onCardClick"
    @keydown.enter="onCardClick"
    @keydown.space.prevent="onCardClick"
  >
    <FeedPostCard
      v-if="item.type === 'POST'"
      :item="item"
      :currentUserId="currentUserId"
      :chatGroups="chatGroups"
      :userName="userName"
      :userAvatar="userAvatar"
      :canManage="canManage"
      @react="$emit('react', $event)"
      @comment="$emit('comment', $event)"
      @repost="$emit('repost', $event)"
      @share="$emit('share', $event)"
      @shareToChat="$emit('shareToChat', $event)"
      @react-comment="$emit('react-comment', $event)"
      @reply="$emit('reply', $event)"
      @load-more-replies="$emit('load-more-replies', $event)"
      @edit="$emit('edit', $event)"
      @delete="$emit('delete', $event)"
      @pin="$emit('pin', $event)"
    />
    <FeedRepostCard
      v-else-if="item.type === 'REPOST'"
      :item="item"
      :currentUserId="currentUserId"
      :chatGroups="chatGroups"
      :userName="userName"
      :userAvatar="userAvatar"
      @react="$emit('react', $event)"
      @comment="$emit('comment', $event)"
      @repost="$emit('repost', $event)"
      @shareToChat="$emit('shareToChat', $event)"
      @react-comment="$emit('react-comment', $event)"
      @reply="$emit('reply', $event)"
      @load-more-replies="$emit('load-more-replies', $event)"
    />
    <FeedPollCard
      v-else-if="item.type === 'POLL' || item.type === 'SPONSORED_POLL'"
      :item="item"
      :currentUserId="currentUserId"
      :chatGroups="chatGroups"
      :userName="userName"
      :userAvatar="userAvatar"
      :canManage="canManage"
      @react="$emit('react', $event)"
      @vote="$emit('vote', $event)"
      @comment="$emit('comment', $event)"
      @repost="$emit('repost', $event)"
      @shareToChat="$emit('shareToChat', $event)"
      @edit="$emit('edit', $event)"
      @delete="$emit('delete', $event)"
      @pin="$emit('pin', $event)"
    />
    <FeedSponsoredCard
      v-else-if="item.type === 'SPONSORED_POST'"
      :item="item"
      @cta="$emit('cta', $event)"
      @hide="$emit('hide', $event)"
      @learnMore="$emit('learnMore', $event)"
    />
    <!-- Legacy campaign/activity cards (from mockHomeFeed) -->
    <FeedCard v-else :card="item" />
  </div>
</template>

<script setup>
import FeedPostCard from "./FeedPostCard.vue";
import FeedRepostCard from "./FeedRepostCard.vue";
import FeedPollCard from "./FeedPollCard.vue";
import FeedSponsoredCard from "./FeedSponsoredCard.vue";
import FeedCard from "../home/FeedCard.vue";

const props = defineProps({
  item: { type: Object, required: true },
  currentUserId: { type: String, default: "" },
  chatGroups: { type: Array, default: () => [] },
  userName: { type: String, default: "" },
  userAvatar: { type: String, default: "" },
  canManage: { type: Boolean, default: false },
  openOnClick: { type: Boolean, default: true },
});

const emit = defineEmits([
  "open",
  "react",
  "comment",
  "repost",
  "share",
  "shareToChat",
  "vote",
  "cta",
  "hide",
  "learnMore",
  "react-comment",
  "reply",
  "load-more-replies",
  "edit",
  "delete",
  "pin",
]);

function onCardClick(e) {
  if (!props.openOnClick) return;
  if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
  const interactive = e.target?.closest(
    "a, button, input, textarea, select, .fmg-cell, .frb, .fpc-comments, [popup-open], [data-popup-open], [sheet-open], [actions-open]",
  );
  if (interactive) return;
  emit("open", props.item);
}
</script>

<style scoped>
.fic--clickable {
  cursor: pointer;
}
</style>
